export default __webpack_public_path__ + "static/1-8808b37967ff32cedbac2deb9fd92326.jpg";